import { render, staticRenderFns } from "./compatibility-icons.vue?vue&type=template&id=3edbd853&"
import script from "./compatibility-icons.vue?vue&type=script&lang=js&"
export * from "./compatibility-icons.vue?vue&type=script&lang=js&"
import style0 from "./compatibility-icons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports